import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import About from './pages/About';
import { FormationPage } from './pages/Formation';
import Formations from './pages/Formations';
import Galery from './pages/Galery';
import Home from './pages/Home';
import Peoples from './pages/Peoples';
import Projects from './pages/Projects';
import Dashboard from "./pages/Dashboard/index";
import Research from "./pages/research ";

export default function AppRoutes() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/sobre" element={<About />} />
        <Route exact path="/formacoes" element={<Formations />} />
        <Route path="/formacao/:id" element={<FormationPage />} />
        <Route exact path="/fotos" element={<Galery />} />
        <Route exact path="/pessoas" element={<Peoples />} />
        <Route exact path="/linhas-de-pesquisa" element={<Research />} />
        <Route exact path="/Dashboard" element={<Dashboard />}/>
        <Route exact path="/Projects" element={<Projects />}/>
      </Routes>
    </HashRouter>
  );
}